import { ThunkResult } from "@/models/common/core/ThunkResult";
import { ShopCircle } from "@/models/scope/shop/ShopCircle";
import { City } from "@/models/scope/localization/City";
import { ShippingContextList } from '@/models/scope/shipping/ShippingContextList';
import {
    AVAILABILITY_DATA_FETCHED_TYPE, BUNDLE_AVAILABILITY_DATA_FETCHED_TYPE,
    SHIPPING_AVAILABILITY_DATA_FETCHED_TYPE,
    SHOP_CIRCLE_FETCHED_TYPE,
    SHOP_DATA_FETCHED_TYPE,
    STOCK_LOCATOR_AVAILABILITY_DATA_FETCHED_TYPE,
    UPDATE_CITY_LIST_DATA_TYPE,
    UPDATE_ERROR_STATUS_TYPE,
    UPDATE_LAYER_PENDING_STATUS_TYPE,
    PRIMARY_SHOP_DATA_FETCHED_TYPE,
    UPDATE_SELECTED_ZIP_CITY_FOR_STOCK_LOC_TYPE,
    UPDATE_AVAILABILITY_PENDING_STATUS_TYPE
} from "@/redux/reducers/responsive/product/productAvailabilityActionTypes";
import {
    AVAILABILITY_DATA_FETCHED,
    STOCK_LOCATOR_AVAILABILITY_DATA_FETCHED,
    UPDATE_ERROR_STATUS, SHOP_CIRCLE_FETCHED,
    PRIMARY_SHOP_DATA_FETCHED, SHOP_DATA_FETCHED,
    UPDATE_LAYER_PENDING_STATUS, UPDATE_CITY_LIST_DATA,
    SHIPPING_AVAILABILITY_DATA_FETCHED,
    UPDATE_SELECTED_ZIP_CITY_FOR_STOCK_LOC,
    BUNDLE_AVAILABILITY_DATA_FETCHED,
    UPDATE_AVAILABILITY_PENDING_STATUS,
} from "@/redux/reducers/responsive/actionsTypes";
import { fetchShopCircle, updatePrimaryShop } from "@/services/shopServices";
import { getProductAvailabilities } from "@/services/productServices";
import { MOBILE_TEMPLATE_VERSION, STOCK_LOCATOR_ERROR_TYPE } from "@/utils/constants";
import {
    calculateProductAvailabilityParamsForProductSheet,
    getAvailabilityShopCircleData,
    getUserIdFromCookie,
    getHistoricShopCirleDataFromLocalStorage,
    getShopCirleDataFromLocalStorage,
    calculateProductAvailabilityParams
} from "@/utils/responsive/utils";
import Cookies from "js-cookie";

interface Params {
    allShops: boolean;
    productId: string;
    didShopChanged?: boolean
}

export const fetchProductAvailabilities = (params: Params, context: string)
    : ThunkResult<AVAILABILITY_DATA_FETCHED_TYPE
        | STOCK_LOCATOR_AVAILABILITY_DATA_FETCHED_TYPE
        | SHIPPING_AVAILABILITY_DATA_FETCHED_TYPE
        | BUNDLE_AVAILABILITY_DATA_FETCHED_TYPE
        | SHOP_DATA_FETCHED_TYPE
        | PRIMARY_SHOP_DATA_FETCHED_TYPE
        | UPDATE_AVAILABILITY_PENDING_STATUS_TYPE
        | UPDATE_ERROR_STATUS_TYPE> => {
    return function (dispatch) {
        if (context == ShippingContextList.BUNDLE_PRODUCT_SHEET) {
            dispatch(updateBundleAvailabilityAction(params.productId, true, undefined));
        } else {
            dispatch(updateAvailabilityPendingStatusAction(true));
        }
        getProductAvailabilities(calculateProductAvailabilityParamsForProductSheet(params.productId))
            .then(response => {
                const availabiltiyData = response.data?.[0];
                if (context === ShippingContextList.BUNDLE_PRODUCT_SHEET) {
                    dispatch(updateBundleAvailabilityAction(params.productId, false, availabiltiyData?.genericAvailability.saleability || undefined));
                } else {
                    dispatch({
                        type: AVAILABILITY_DATA_FETCHED,
                        payload: {
                            availabilityByShops: availabiltiyData?.availabilityByShops || [],
                            detailedAvailablity: availabiltiyData?.detailedAvailablity || {},
                            genericAvailability: availabiltiyData?.genericAvailability || {},
                        }
                    });
                }
                if (params.didShopChanged && availabiltiyData?.availabilityByShops) {
                    if (window.appData.deviceType === MOBILE_TEMPLATE_VERSION) {
                        const shopInfos = availabiltiyData?.availabilityByShops[0]?.shop?.shopInfos;
                        dispatch({
                            type: SHOP_DATA_FETCHED,
                            payload: {
                                shopId: shopInfos.id,
                                shopName: shopInfos.name,
                                shopUrl: shopInfos.url,
                                shopAndWharehouseData: availabiltiyData?.availabilityByShops[0]?.shop,
                                openingWharehouseSchedule: availabiltiyData?.availabilityByShops[0]?.shop.warehouseInfos.schedule,
                                openingShopSchedule: shopInfos.schedule,
                                shopNextDayOpen: shopInfos.shopNextDayOpen,
                                shopNextDayOpenSchedule: shopInfos.shopNextDayOpenSchedule
                            },
                        });
                    } else {
                        dispatch({
                            type: PRIMARY_SHOP_DATA_FETCHED,
                            payload: { shopData: availabiltiyData?.availabilityByShops[0]?.shop },
                        });
                    }
                }
            }).catch((error) => {
                //TODO SES thow exception
                if (context == ShippingContextList.BUNDLE_PRODUCT_SHEET) {
                    dispatch(updateBundleAvailabilityAction(params.productId, false, undefined));
                } else {
                    dispatch(updateAvailabilityPendingStatusAction(false));
                }
                console.log(error);
            })
    }
}

export const getShopCircleForStockLocator = (
    calculationParams: string,
    calculationMethod = 'ByInsee',
    productId: string,
    context: ShippingContextList,
    selectedZipCity?: { zipCode: string, cityName: string }
)
    : ThunkResult<STOCK_LOCATOR_AVAILABILITY_DATA_FETCHED_TYPE
        | SHOP_CIRCLE_FETCHED_TYPE
        | UPDATE_LAYER_PENDING_STATUS_TYPE
        | UPDATE_ERROR_STATUS_TYPE> => {
    return function (dispatch) {
        fetchShopCircle(calculationMethod, calculationParams)
            .then(response => {
                let shopCircle = response.data;
                if (shopCircle.circleShops.length == 0) {
                    dispatch(updateLayerPendingStatusAction(false));
                    dispatch(updateErrorStatusAction(STOCK_LOCATOR_ERROR_TYPE.SHOP_CIRCLE, true));
                    return;
                }
                dispatch({
                    type: SHOP_CIRCLE_FETCHED,
                    payload: { shopCircle: response.data.circleShops },
                });
                if (context == ShippingContextList.SHIPPING_LAYER) {
                    //if context is shipping layer we must update the last serach infos in stock loc + fetch the infos for only one shop!
                    if (!!selectedZipCity) {
                        shopCircle.zipCode = selectedZipCity.zipCode;
                        shopCircle.city = selectedZipCity.cityName;
                    }
                    localStorage.setItem('historicSearchShopCircle', JSON.stringify({
                        zipCode: shopCircle.zipCode,
                        city: shopCircle.city,
                        circleShops: shopCircle.circleShops?.slice(0, 1),
                        modificationDate: shopCircle.modificationDate
                    }));
                    shopCircle = {
                        ...response.data,
                        circleShops: response.data.circleShops.slice(0, 1)
                    }
                }
                dispatch(getStockLocatorAvailability(productId, context, shopCircle));
            })
            .catch((error) => {
                console.log(error);
                dispatch(updateLayerPendingStatusAction(false));
                dispatch(updateErrorStatusAction(STOCK_LOCATOR_ERROR_TYPE.SHOP_CIRCLE, true));
            });
    }
}

export const getStockLocatorAvailability = (productId: string, context: string, shopCircleParam?: ShopCircle)
    : ThunkResult<STOCK_LOCATOR_AVAILABILITY_DATA_FETCHED_TYPE
        | UPDATE_ERROR_STATUS_TYPE
        | SHIPPING_AVAILABILITY_DATA_FETCHED_TYPE
        | UPDATE_LAYER_PENDING_STATUS_TYPE> => {
    return function (dispatch) {
        !shopCircleParam && dispatch(updateLayerPendingStatusAction(true));
        let shopCircleInfos;
        if (!!shopCircleParam) {
            shopCircleInfos = shopCircleParam;
        } else if (context == ShippingContextList.STOCK_LOCATOR) {
            shopCircleInfos = getShopCirleDataFromLocalStorage();
        } else if (context == ShippingContextList.SHIPPING_LAYER) {
            shopCircleInfos = getShopCirleDataFromLocalStorage();
            if(!shopCircleInfos?.circleShops) {
                shopCircleInfos = getShopCirleDataFromLocalStorage();
                shopCircleInfos = {
                    ...shopCircleInfos,
                    circleShops: shopCircleInfos.circleShops?.slice(0, 1)
                }
                localStorage.setItem('historicSearchShopCircle', JSON.stringify({
                    zipCode: shopCircleInfos.zipCode,
                    city: shopCircleInfos.city,
                    circleShops: shopCircleInfos.circleShops,
                    modificationDate: shopCircleInfos.modificationDate
                }));
            }
        }
        getProductAvailabilities(calculateProductAvailabilityParams(
            shopCircleInfos.circleShops,
            productId,
            shopCircleInfos.zipCode,
            shopCircleInfos.city,
            context == ShippingContextList.SHIPPING_LAYER ? ShippingContextList.PRODUCT_SHEET : ShippingContextList.STOCK_LOCATOR
        )).then((response) => {
            const availabiltiyData = response.data?.[0];
            if (context == ShippingContextList.STOCK_LOCATOR) {
                dispatch({
                    type: STOCK_LOCATOR_AVAILABILITY_DATA_FETCHED,
                    payload: {
                        stockLocatorAvailabilityByShops: availabiltiyData?.availabilityByShops || [],
                    }
                });
            } else if (context == ShippingContextList.SHIPPING_LAYER) {
                dispatch({
                    type: SHIPPING_AVAILABILITY_DATA_FETCHED,
                    payload: {
                        shippingAvailabilityByShop: {
                            availabilityByShop: availabiltiyData?.availabilityByShops?.[0] || {},
                        },
                    }
                });
            }
        }).catch(error => {
            console.log(error);
            dispatch(updateErrorStatusAction(STOCK_LOCATOR_ERROR_TYPE.AVAILABILITY, true));
        }).finally(() => {
            dispatch(updateLayerPendingStatusAction(false));
        })
    }
}

export const updateShopCircleInDdAndUserStorage = (
    calculationParams: string,
    calculationMethod: string,
    productId: string,
    context: string = "",
    selectedZipCity?: { zipCode: string, cityName: string }
): ThunkResult<SHOP_CIRCLE_FETCHED_TYPE> => {
    return function (dispatch) {
        let putParams = {
            CalculationParams: calculationParams,
            CalculationMethod: calculationMethod
        }
        updatePrimaryShop(getUserIdFromCookie(), putParams)
            .then((response) => {
                const shopCircle = response.data;
                if (!!selectedZipCity) {
                    shopCircle.zipCode = selectedZipCity.zipCode;
                    shopCircle.city = selectedZipCity.cityName;
                }
                localStorage.setItem('shopCircle', JSON.stringify(shopCircle));
                Cookies.set('availabilityShopCircle', JSON.stringify(getAvailabilityShopCircleData(shopCircle)), {
                    path: "/",
                    expires: 365,
                    secure: true,
                    sameSite: "None",
                });
                const historicShopCirleDataFromLocalStorage = getHistoricShopCirleDataFromLocalStorage();
                if (context == ShippingContextList.SHIPPING_LAYER || Object.keys(historicShopCirleDataFromLocalStorage).length === 0) {
                    localStorage.setItem('historicSearchShopCircle', JSON.stringify({
                        zipCode: shopCircle.zipCode,
                        city: shopCircle.city,
                        circleShops: shopCircle.circleShops?.slice(0, 1),
                        modificationDate: shopCircle.modificationDate
                    }));
                }
                dispatch({
                    type: SHOP_CIRCLE_FETCHED,
                    payload: { shopCircle: response.data.circleShops },
                });
                dispatch(fetchProductAvailabilities({
                    allShops: false,
                    productId,
                    didShopChanged: true,
                },
                    ShippingContextList.PRODUCT_SHEET,
                ));
            })
            .catch((error) => {
                // TODO handle error
                console.log('error', error);
                dispatch(updateLayerPendingStatusAction(false));
            })
    }
}

export const updateErrorStatusAction = (type: string, status: boolean): ThunkResult<UPDATE_ERROR_STATUS_TYPE> => {
    return function (dispatch) {
        dispatch({
            type: UPDATE_ERROR_STATUS,
            payload: {
                type,
                status,
            },
        });
    }
}

export const updateSelectedZipCodeCityAction = (selectedZipCodeCity?: { zipCode: string, cityName: string }):
    ThunkResult<UPDATE_SELECTED_ZIP_CITY_FOR_STOCK_LOC_TYPE> => {
    return function (dispatch) {
        const actionName = UPDATE_SELECTED_ZIP_CITY_FOR_STOCK_LOC
        dispatch({
            type: actionName,
            payload: {
                selectedZipCodeCity
            },
        });
    }
}

export const updateLayerPendingStatusAction = (pendingStatus: boolean): ThunkResult<UPDATE_LAYER_PENDING_STATUS_TYPE> => {
    return function (dispatch) {
        dispatch({
            type: UPDATE_LAYER_PENDING_STATUS,
            payload: {
                pendingStatus,
            },
        });
    }
}

export const updateAvailabilityPendingStatusAction = (pendingStatus: boolean): ThunkResult<UPDATE_LAYER_PENDING_STATUS_TYPE> => {
    return function (dispatch) {
        dispatch({
            type: UPDATE_AVAILABILITY_PENDING_STATUS,
            payload: {
                pendingStatus,
            },
        });
    }
}

export const updateBundleAvailabilityAction = (productId: string, pendingStatus: boolean, saleability?: string): ThunkResult<BUNDLE_AVAILABILITY_DATA_FETCHED_TYPE> => {
    return function (dispatch) {
        dispatch({
            type: BUNDLE_AVAILABILITY_DATA_FETCHED,
            payload: {
                pendingStatus,
                productId,
                saleability,
            },
        });
    }
}

export const updateCityListDataAction = (cityList: City[]): ThunkResult<UPDATE_CITY_LIST_DATA_TYPE> => {
    return function (dispatch) {
        dispatch({
            type: UPDATE_CITY_LIST_DATA,
            payload: { cityList }
        });
    }
}